import { render, staticRenderFns } from "./recommendItem.vue?vue&type=template&id=1ce1ca18&scoped=true&"
import script from "./recommendItem.vue?vue&type=script&lang=ts&"
export * from "./recommendItem.vue?vue&type=script&lang=ts&"
import style0 from "./recommendItem.vue?vue&type=style&index=0&id=1ce1ca18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce1ca18",
  null
  
)

export default component.exports